import { render, staticRenderFns } from "./NoticeUserList.vue?vue&type=template&id=24af1c11&scoped=true"
import script from "./NoticeUserList.vue?vue&type=script&lang=js"
export * from "./NoticeUserList.vue?vue&type=script&lang=js"
import style0 from "./NoticeUserList.vue?vue&type=style&index=0&id=24af1c11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24af1c11",
  null
  
)

export default component.exports